import { render, staticRenderFns } from "./InformForm.vue?vue&type=template&id=5312b44e&scoped=true"
import script from "./InformForm.vue?vue&type=script&lang=js"
export * from "./InformForm.vue?vue&type=script&lang=js"
import style0 from "./InformForm.vue?vue&type=style&index=0&id=5312b44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5312b44e",
  null
  
)

export default component.exports